var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPancakeSwap = function SvgPancakeSwap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "#fff",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.199,
    cy: 12.33,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.164 20.299c-2.336-.002-4.217-.562-5.532-1.569-1.33-1.019-2.035-2.464-2.035-4.1 0-1.576.704-2.713 1.5-3.48a6.61 6.61 0 0 1 1.794-1.21 24.949 24.949 0 0 1-.365-1.22c-.162-.602-.321-1.308-.321-1.826 0-.613.133-1.23.494-1.708.38-.505.954-.776 1.643-.776.54 0 .997.2 1.355.545.343.33.57.767.728 1.224.276.802.384 1.81.414 2.815h.66c.03-1.006.138-2.013.415-2.815.157-.457.385-.894.728-1.224a1.906 1.906 0 0 1 1.354-.545c.69 0 1.263.271 1.644.776.36.479.494 1.095.494 1.708 0 .518-.159 1.224-.32 1.827-.122.45-.257.886-.366 1.219.48.222 1.169.607 1.793 1.21.797.768 1.501 1.904 1.501 3.48 0 1.636-.706 3.081-2.036 4.1-1.314 1.007-3.195 1.567-5.53 1.569h-.012Zm-1.817-6.457c0 .777-.364 1.182-.812 1.182-.449 0-.813-.405-.813-1.182 0-.778.364-1.183.813-1.183.448 0 .812.405.812 1.183Zm4.468 1.182c.448 0 .812-.405.812-1.182 0-.778-.364-1.183-.812-1.183-.449 0-.813.405-.813 1.183 0 .777.364 1.182.813 1.182Z",
    fill: "#000"
  })));
};

export default SvgPancakeSwap;